// src/components/table/Datatable.jsx
import React from "react";
import { ReactComponent as SortIcon } from "../../assets/images/Sort.svg";

function cx(...arr) {
  return arr.filter(Boolean).join(" ");
}

export default function DataTable({
  columns,
  data,
  rowKey = (row, idx) => row?.id ?? idx,
  rowHeight = "h-18",
  headerBg = "bg-[#F5F5F5]",
  striped = true,
  containerClassName = "",
  tableMinWidth = "min-w-[980px]",
  width,
  sortKey = "",
  sortDir = "asc",
  onSort = () => { },
}) {
  return (
    <div className={cx("overflow-x-auto rounded-xl border-slate-200 bg-white", containerClassName)}>
      {/* ✅ สำคัญ: table-fixed */}
      <table className={cx("w-full table-fixed text-sm", tableMinWidth)}>
        <thead className={cx(headerBg, "text-slate-600")}>
          <tr>
            {columns.map((c) => {
              const canSort = !!c.sortable && !!c.sortKey;
              const active = canSort && sortKey === c.sortKey;

              return (
                <th
                  key={c.key}
                  onClick={canSort ? () => onSort(c.sortKey) : undefined}
                  className={cx(
                    // ✅ สำคัญ: min-w-0 + overflow hidden ให้ header ตัด … ได้
                    "min-w-0 text-left px-2 py-3 bg-[#F2F9FE] border-b-2 border-[#047DED]",
                    canSort && "cursor-pointer select-none",
                    active ? "text-[#047DED]" : "text-dark-label",
                    c.pl,
                    c.headerClassName
                  )}
                >
                  {/* ✅ wrapper ต้อง min-w-0 */}
                  <div className="min-w-0 flex items-center gap-2">
                    {/* ✅ ตรงนี้ render title ตรงๆ (title เป็น ReactNode) */}
                    <div className="min-w-0 flex-1 truncate">
                      {c.title}
                    </div>

                    {canSort && (
                      <SortIcon
                        className={cx(
                          "h-4 w-4 flex-shrink-0 transition-transform",
                          active ? "text-[#047DED]" : "text-slate-400",
                          active && sortDir === "desc" && "rotate-180"
                        )}
                      />
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {data.map((row, idx) => (
            <tr
              key={rowKey(row, idx)}
              className={cx(
                "border-slate-100",
                striped && idx % 2 === 1 && "bg-slate-900/[0.015]"
              )}
            >
              {columns.map((c) => (
                <td
                  key={c.key}
                  className={cx(
                    // ✅ ใส่ px-4 ให้ตรง header + min-w-0 เพื่อให้ truncate ทำงาน
                    "min-w-0 px-2 py-1 align-middle",
                    rowHeight,
                    c.className
                  )}
                >
                  {/* ✅ wrapper ที่เป็นจุด truncate ใน cell */}
                  <div className="min-w-0">
                    {c.render ? c.render(row, idx) : row?.[c.key]}
                  </div>
                </td>
              ))}
            </tr>
          ))}

          {data.length === 0 && (
            <tr>
              <td className="px-4 py-10 text-center text-slate-400" colSpan={columns.length}>
                ไม่มีข้อมูล
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
